import { Link } from 'react-router-dom';
import { QUESTION_COUNT } from '../data/questions.js';
import { CATEGORIES } from '../data/categories.js';

// YouTube-style "up next" list of other quizzes shown beside the quiz.
export default function RecommendedQuizzes({ currentId, count = 6 }) {
  // Stable, deterministic pick of other categories (offset by the current one).
  const others = CATEGORIES.filter((c) => c.id !== currentId);
  const start = Math.max(0, CATEGORIES.findIndex((c) => c.id === currentId));
  const list = Array.from({ length: Math.min(count, others.length) }, (_, i) =>
    others[(start + i) % others.length],
  );

  return (
    <aside className="w-full">
      <h2 className="text-sm font-black uppercase tracking-widest text-slate-500 mb-3">
        More Quizzes
      </h2>
      <div className="flex gap-3 overflow-x-auto pb-2 lg:flex-col lg:gap-2.5 lg:overflow-visible">
        {list.map((cat) => (
          <Link
            key={cat.id}
            to={`/play?cat=${cat.id}`}
            className="group shrink-0 w-60 lg:w-full surface-card rounded-2xl p-2.5 flex items-center gap-3 transition-transform duration-200 hover:-translate-y-0.5"
          >
            <div
              className={`relative shrink-0 w-24 h-16 rounded-xl overflow-hidden bg-gradient-to-br ${cat.gradient} flex items-center justify-center`}
            >
              <span className="absolute inset-0 halftone opacity-25" />
              <span className="relative text-3xl drop-shadow group-hover:scale-110 transition-transform">
                {cat.emoji}
              </span>
            </div>
            <div className="min-w-0 flex-1">
              <p className="text-sm font-black text-slate-900 leading-tight truncate">
                {cat.title}
              </p>
              <p className="mt-0.5 text-xs font-bold text-slate-400">
                {QUESTION_COUNT} questions · Free
              </p>
            </div>
          </Link>
        ))}
      </div>
    </aside>
  );
}
